// extracted by mini-css-extract-plugin
export default {"PageTitle":"TermOfAcceptancePage_PageTitle__v8GAV","ParagraphTitle":"TermOfAcceptancePage_ParagraphTitle__ZEz+j"};